export default __webpack_public_path__ + "static/media/8062e1d483ea781e70f68371aec9ffc0.svg";